import type { PropsWithChildren, ReactNode } from 'react';
import styles from './Typography.module.css';

export function Eyebrow({ children }: PropsWithChildren) {
  return <span className={styles.eyebrow}>{children}</span>;
}

export function EyebrowSep() {
  return <span className={styles.eyebrowSep}>/</span>;
}

export function Display({ children }: PropsWithChildren) {
  return <h1 className={styles.display}>{children}</h1>;
}

export function Headline({ children }: PropsWithChildren) {
  return <h2 className={styles.headline}>{children}</h2>;
}

export function Lede({ children }: PropsWithChildren) {
  return <p className={styles.lede}>{children}</p>;
}

export function Body({
  children,
  maxWidth,
  muted,
}: PropsWithChildren<{ maxWidth?: string; muted?: boolean }>) {
  return (
    <p
      className={`${styles.body} ${muted ? styles.bodyMuted : ''}`}
      style={maxWidth ? { maxWidth } : undefined}
    >
      {children}
    </p>
  );
}

export function Tag({
  children,
  variant = 'accent',
}: PropsWithChildren<{ variant?: 'accent' | 'mute' }>) {
  return <span className={`${styles.tag} ${variant === 'mute' ? styles.tagMute : ''}`}>{children}</span>;
}

/**
 * Italic emphasis inside a Display or Headline, rendered in the accent color.
 * Use sparingly — one per heading is the rule.
 */
export function Em({ children }: { children: ReactNode }) {
  return <em className={styles.em}>{children}</em>;
}

export function Kicker({ children }: PropsWithChildren) {
  return <span className={styles.kicker}>{children}</span>;
}
